import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { Container, Kicker } from '../components/ui/Primitives';
import { Seo } from '../components/Seo';
import { ApplicationForm } from '../components/careers/ApplicationForm';
import { getPosition, INTERNSHIP_TERMS } from '../data/careers';
import { breadcrumbSchema } from '../lib/seo';
export function CareerApply() {
  const [params] = useSearchParams();
  const initial = params.get('position') ?? '';
  const position = getPosition(initial);
  return <>
      <Seo title="Apply for an internship" description="Apply for an internship at Cavalla Solution in Kigali. One form, no account needed, and a reply within two weeks." path="/careers/apply" noIndex jsonLd={[breadcrumbSchema([{
      name: 'Home',
      path: '/'
    }, {
      name: 'Careers',
      path: '/careers'
    }, {
      name: 'Apply',
      path: '/careers/apply'
    }])]} data-id="element-2214" data-mp="1n8m6f9ko4og" />

      <section className="surface-dark" data-id="element-2215" data-mp="3jcpxwke9lke7">
        <Container className="py-12 sm:py-14" data-id="element-2216" data-mp="3ndtbf08ub4c9">
          <nav aria-label="Breadcrumb" className="mb-8" data-id="element-2217" data-mp="3nciar9aoycpd">
            <ol className="flex flex-wrap items-center gap-2 text-small text-white/55" data-id="element-2218" data-mp="39eagxa8ybrif">
              <li data-id="element-2219" data-mp="3ed4yy9z3hc1h">
                <Link to="/careers" className="hover:text-white" data-id="element-2220" data-mp="3eclqdjvc4004">Careers</Link>
              </li>
              {position && <>
                  <li aria-hidden="true" data-id="element-2221" data-mp="2zmxoagfbwxbc">
                    <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-2222" data-mp="34ep8m97w66t1" />
                  </li>
                  <li data-id="element-2223" data-mp="2qnj1ps2a96w4">
                    <Link to={`/careers/${position.slug}`} className="hover:text-white" data-id="element-2224" data-mp="2qo2gizwmzf5x">{position.title}</Link>
                  </li>
                </>}
              <li aria-hidden="true" data-id="element-2225" data-mp="2vk9cq0z8dcao">
                <ChevronRightIcon className="h-3.5 w-3.5" data-id="element-2226" data-mp="2gp38njjp3njz" />
              </li>
              <li aria-current="page" className="text-white/80" data-id="element-2227" data-mp="2lo6db2vrjrrf">Apply</li>
            </ol>
          </nav>
          <Kicker data-id="element-2228" data-mp="22kcnzgu5tm2w">Application</Kicker>
          <h1 className="mt-4 max-w-3xl font-display text-[30px] font-light leading-tight text-white sm:text-[42px]" data-id="element-2229" data-mp="22le07omwwem7">
            {position ? `Apply for ${position.title}` : 'Apply for an internship'}
          </h1>
          <p className="mt-5 max-w-2xl text-[17px] text-white/72" data-id="element-2230" data-mp="1suaz4mtzfzmx">
            One form, no account. It takes about ten minutes with your CV to hand. All positions are based in{' '}
            {INTERNSHIP_TERMS.location}, for {INTERNSHIP_TERMS.duration}.
          </p>
        </Container>
      </section>

      <Container className="py-12 sm:py-16" data-id="element-2231" data-mp="2ghj413ni16of">
        <div className="mx-auto max-w-3xl" data-id="element-2232" data-mp="2bjpzsg5ramqs">
          <ApplicationForm initialPosition={initial} data-id="element-2233" data-mp="2biodtgn7cfua" />
        </div>
      </Container>
    </>;
}